// noinspection DuplicatedCode
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableExtendFinance } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { useNavigate, useParams } from "react-router-dom";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";

const PattyCashPage = ({}) => {
  // Format default yang benar untuk input month (YYYY-MM)
  const currentDate = new Date();
  const defaultBulanValue = `${currentDate.getFullYear()}-${(
    currentDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}`;

  let initialState = {
    Bulan: defaultBulanValue,
  };

  const validations = [];
  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations,
  );

  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit"),
  );
  const params = useParams();
  const [search, setSearch] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);

  // Initial param dengan format yang benar untuk API
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: params.BisnisUnit,
    Menu: "PC",
    Bulan: (currentDate.getMonth() + 1).toString(), // Format: 1-12
    Tahun: currentDate.getFullYear().toString(), // Format: 2024
    Type: "pettycash",
  });

  const mutationData = useMutation((param) =>
    fetchPost("Accounting/CashJournalgetV2", param),
  );
  const KirimTrans = useMutation((formData) =>
    fetchPost("Accounting/CashJournal", formData),
  );

  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    mutationData.mutate(param);
  }, [KirimTrans.status]);

  useEffect(() => {
    bisnisUnit.mutate();
    mutationData.mutate(param);
  }, []);

  // Format currency helper - SAMA SEPERTI DI MONITORING
  const formatCurrency = useCallback((value) => {
    if (value === null || value === undefined || value === "") return "Rp 0";
    
    // Handle berbagai format nilai
    let num = 0;
    if (typeof value === 'string') {
      // Hapus karakter non-numeric kecuali titik dan koma
      const cleaned = value.replace(/[^\d,-]/g, '').replace(',', '.');
      num = parseFloat(cleaned) || 0;
    } else if (typeof value === 'number') {
      num = value;
    } else {
      num = 0;
    }
    
    if (isNaN(num)) return "Rp 0";

    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);
  }, []);

  // Fungsi untuk mendapatkan nilai nominal dari berbagai kemungkinan field
  const getNominalValue = useCallback((row) => {
    // Coba ambil dari berbagai field yang mungkin berisi nominal
    const nominal = row.Nominal || row.Amount || row.Jumlah || row.Nilai || row.Total || 0;
    
    // Konversi ke number jika string
    if (typeof nominal === 'string') {
      const cleaned = nominal.replace(/[^\d,-]/g, '').replace(',', '.');
      return parseFloat(cleaned) || 0;
    }
    
    return parseFloat(nominal) || 0;
  }, []);

  const editOpener = (detail) => {
    navigate("/finance/transaction/form-kas-bank-edit/" + detail);
  };

  const kirim = (detail) => {
    navigate("/finance/transaction/form-kas-bank/" + detail + "/true");
  };

  // Header dengan custom cell untuk Nominal menggunakan formatCurrency
  const header = useMemo(() => [
    { name: "Kas Bank ID", key: "CashJournalID", modifiers: "Text" },
    { name: "Kepada", key: "DariKepada", modifiers: "Text" },
    { name: "Jenis Transaksi", key: "JenisTransaksi", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Tanggal Entry", key: "CreateDate", modifiers: "Date" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Status", key: "Status", modifiers: "Text" },
    { 
      name: "Nominal", 
      key: "Nominal", 
      modifiers: "Currency",
      selector: (row) => getNominalValue(row),
      cell: (row) => (
        <div className="text-right font-mono text-xs font-medium">
          {formatCurrency(getNominalValue(row))}
        </div>
      ),
      sortable: true,
      right: true,
      minWidth: "150px",
    },
    { name: "Actions", key: "Edit", modifiers: "Button" },
  ], [formatCurrency, getNominalValue]);

  const navigate = useNavigate();

  const filterData = (event) => {
    const filtered =
      mutationData.data?.filter(({ NamaKaryawan }) =>
        NamaKaryawan?.toLowerCase().includes(event.target.value.toLowerCase()),
      ) || [];
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    navigate("/finance/transaction/form-PettyCash/" + params.BisnisUnit);
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam((prev) => ({
      ...prev,
      start: newStart,
      count: count,
      search: "",
    }));
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }

    const newCountValue = newCount === "-1" ? count : parseInt(newCount);
    const newStartValue = newCount === "-1" ? 0 : start;

    setParam((prev) => ({
      ...prev,
      start: newStartValue,
      count: newCountValue,
      search: search,
    }));

    setPage(1);
    setCount(newCountValue);
    setStart(newStartValue);
    setMaxPage(Math.ceil(calc / newCountValue));
  }

  function handleModal(value) {}

  // Fungsi untuk konversi format YYYY-MM ke format API
  const parseBulanToAPIFormat = (bulanValue) => {
    if (!bulanValue) {
      return {
        bulan: (currentDate.getMonth() + 1).toString(),
        tahun: currentDate.getFullYear().toString(),
      };
    }

    try {
      // Jika format YYYY-MM (dari input month)
      if (typeof bulanValue === "string" && bulanValue.includes("-")) {
        const [tahun, bulan] = bulanValue.split("-");
        return {
          bulan: parseInt(bulan).toString(), // Konversi "01" -> "1"
          tahun: tahun,
        };
      }
      // Jika sudah format object atau lainnya
      else {
        const date = new Date(bulanValue);
        if (!isNaN(date.getTime())) {
          return {
            bulan: (date.getMonth() + 1).toString(),
            tahun: date.getFullYear().toString(),
          };
        }
      }
    } catch (error) {
      console.error("Error parsing bulan:", error);
    }

    // Fallback ke bulan dan tahun saat ini
    return {
      bulan: (currentDate.getMonth() + 1).toString(),
      tahun: currentDate.getFullYear().toString(),
    };
  };

  function filterApi() {
    // Konversi format bulan untuk API
    const { bulan, tahun } = parseBulanToAPIFormat(values.Bulan);

    const formData = {
      start: start,
      count: count,
      search: search,
      BisnisUnitID: params.BisnisUnit,
      Menu: "PC",
      Bulan: bulan, // Format: 1-12
      Tahun: tahun, // Format: 2024
      Type: "pettycash",
    };

    console.log("Filter data:", formData);
    mutationData.mutate(formData);
  }

  // Handler untuk input bulan
  const handleBulanChange = (event) => {
    const { value } = event.target;
    console.log("Bulan dipilih:", value); // Debug: lihat value yang dipilih
    customHandler({ target: { name: "Bulan", value } });
  };

  // Log data untuk debugging (bisa dihapus setelah selesai)
  useEffect(() => {
    if (mutationData.data && mutationData.data.length > 0) {
      console.log("Sample data:", mutationData.data[0]);
      console.log("Sample nominal:", mutationData.data[0].Nominal);
    }
  }, [mutationData.data]);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"bulan"}
                    name={"Bulan"}
                    title={"Bulan"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Buka data
                  </label>
                  <button
                    type="button"
                    onClick={filterApi}
                    disabled={mutationData.isLoading}
                    className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 disabled:opacity-50"
                  >
                    {mutationData.isLoading ? "Loading..." : "Buka"}
                  </button>
                </div>
              </div>
              <div className="flex flex-col content-center">
                {mutationData.isLoading ? (
                  <div className="text-center py-4">Loading data...</div>
                ) : mutationData.error ? (
                  <div className="text-center py-4 text-red-500">
                    Error: {mutationData.error.message}
                  </div>
                ) : (
                  <DynamicTableExtendFinance
                    types="penerimaan-barang"
                    data={mutationData.data || []}
                    header={header}
                    menuController={filterData}
                    Master={true}
                    currentPage={page}
                    maxPage={maxPage}
                    name={"UserPC"}
                    OnClick={ModalOpener}
                    updateCount={handleUpdateCount}
                    count={count}
                    updatePage={handleUpdatePage}
                    modal={handleModal}
                    editor={editOpener}
                    kirim={kirim}
                    // "Revisi" = Status 2 = DITOLAK. ApprovePattyCash bisa menolak,
                    // jadi tanpa ini dokumen yang ditolak mentok tanpa tombol Kirim.
                    kirimStatus={["Menunggu Dikirim", "Revisi"]}
                    primarykey={"CashJournalID"}
                  />
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PattyCashPage;